export function overflowIsTurnedOff(waitTime: number | null): boolean {
  return waitTime === null;
}
